/* eslint-disable camelcase */
import Dropdown from 'common/components/Dropdown'
import { useState } from 'react'

interface IRadioDropdown {
  error: boolean
  data: {
    id: string
    question: string
    answer_type: string
    options?: Array<{
      id: string
      option: string
      image_url: string
      next_questions?: {
        url: string
        method: string
      }
    }>
  }
  defaultValue?: string
  onChange: (id: string, val: string) => void
}

function RadioDropdown({
  error = false,
  onChange,
  data,
  defaultValue = '',
}: IRadioDropdown): JSX.Element {
  const [value, setValue] = useState(defaultValue)

  const handleChange = (val) => {
    setValue(val)
    const optIndex = data?.options.findIndex((op) => op.id === val)
    let valueSelected = val
    if (optIndex >= 0) {
      valueSelected = data?.options?.[optIndex]
    }
    onChange(data?.id, valueSelected)
  }

  return (
    <Dropdown
      width="480px"
      height="55px"
      heightList="190px"
      margin="0 0 20px"
      placeholder={data?.question}
      value={value}
      onChange={(val) => handleChange(val)}
      required
      error={error}
      helperText={error && `${data?.question} harus diisi`}
    >
      {data?.options?.map((opt) => {
        return (
          <option key={opt.id} value={opt.id}>
            {opt?.option}
          </option>
        )
      })}
    </Dropdown>
  )
}

export default RadioDropdown
